import { Button } from "components/Button/Button";
import { IconCollection } from "components/Icon/IconCollection";
import styles from "./SearchButton.module.scss";

interface SearchButtonProps {
    /** Runs the search. This is a plain (type="button") control that triggers the
     *  search via onClick — it deliberately does NOT rely on native form
     *  submission. The logs filter is mounted inside the record screen's main
     *  <form>, and a nested <form> + native (GET) submit dropped the record id
     *  from the URL (operator-task-fe-record-log-search-field-triggers-not-found-
     *  screen); driving the search explicitly makes a native navigation
     *  impossible. */
    onSearch: () => void;
    className?: string;
}

export const SearchButton = ({ onSearch, className }: SearchButtonProps) => (
    <Button
        onClick={onSearch}
        icon={IconCollection.magnify}
        variation="primary"
        label="Search"
        className={`${styles.clearSearchButton} ${className ?? ""}`}
    />
);
